import { NgModule } from '@angular/core';
import { TranslateModule } from '../translate';
//import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatRadioModule} from '@angular/material/radio';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatChipsModule} from '@angular/material/chips';
import {MatListModule} from '@angular/material/list';
import {MatStepperModule} from '@angular/material/stepper';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';


@NgModule({
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule, MatTableModule, MatPaginatorModule, MatProgressBarModule,
        MatDialogModule, MatTabsModule, MatGridListModule, MatExpansionModule, MatAutocompleteModule
        , MatProgressSpinnerModule, MatInputModule, MatFormFieldModule, MatGridListModule, MatChipsModule, MatStepperModule, MatSlideToggleModule,
        MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatInputModule,
        MatOptionModule,
        MatFormFieldModule, MatRadioModule, MatSnackBarModule, MatListModule, TranslateModule, MatButtonToggleModule, MatTooltipModule,
       // AngularMultiSelectModule, 
        MatCheckboxModule, MatSortModule
    ],
    exports: [
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatCardModule, MatTableModule, MatPaginatorModule, MatProgressBarModule,
        MatDialogModule, MatTabsModule, MatGridListModule, MatExpansionModule, MatAutocompleteModule
        , MatProgressSpinnerModule, MatInputModule, MatFormFieldModule, MatGridListModule, MatChipsModule, MatStepperModule, MatSlideToggleModule,
        MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatInputModule,
        MatOptionModule,
        MatFormFieldModule, MatRadioModule, MatSnackBarModule, MatListModule, TranslateModule, MatButtonToggleModule, MatTooltipModule,
        //AngularMultiSelectModule,
         MatCheckboxModule, MatSortModule
    ],

})
export class MaterialModule { }
